import React, { Component } from 'react';
import Ink from 'react-ink';
import PropTypes from 'prop-types';

import { getActiveSlideId, getSlidesToShow } from '../../helpers/galleryUtils/utils';
import GalleryComponent from './GalleryComponent';
import GalleryMiniContainer from './galleryActiveItem/GalleryMiniContainer';

import './Style';

const directionEnum = Object.freeze({
    prev: 'prev',
    next: 'next'
});

class GalleryBottomComponent extends Component {
    constructor(props) {
        super(props);

        this.galleryAfterChange = this.galleryAfterChange.bind(this);

        this.state = {
            gallerySecondarySettings: {
                dots: false,
                infinite: true,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                draggable: true,
                arrows: false,
                centerMode: true,
                swipeToSlide: true,
                focusOnSelect: true,
                afterChange: this.galleryAfterChange,
                useTransform: false,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1380,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 180,
                        settings: {
                            slidesToShow: 5
                        }
                    },
                    {
                        breakpoint: 5000,
                        settings: {
                            slidesToShow: 7
                        }
                    }
                ]
            }
        }

        this.slickTo = this.slickTo.bind(this);
    }

    slickTo(direction) {
        const { images, activeSlideName } = this.props;
        const isEnoughImages = images.length >= getSlidesToShow(this.state.gallerySecondarySettings);
        if (direction === directionEnum.next) {
            if (!isEnoughImages) {
                if (getActiveSlideId(images, activeSlideName) + 1 < images.length) {
                    this.sliderRef.slickNext();
                } else {
                    this.sliderRef.slickGoTo(0);
                }
            } else {
                this.sliderRef.slickNext();
            }
        }
        if (direction === directionEnum.prev) {
            if (!isEnoughImages) {
                if (getActiveSlideId(images, activeSlideName) > 0) {
                    this.sliderRef.slickPrev();
                } else {
                    this.sliderRef.slickGoTo(images.length - 1);
                }
            } else {
                this.sliderRef.slickPrev();
            }
        }
    }

    galleryAfterChange(e) {
        this.props.galleryAfterChange(e);
    }

    render() {
        const {
            imagesPath,
            imageSizeParams,
            images,
            activeSlideName
        } = this.props;

        return (
            <div
                ref={
                    galleryContainer => this.galleryContainer = galleryContainer
                }
                className={
                    this.props.galleryVisible
                        ? 'gallery-container-bottom'
                        : 'gallery-container-bottom hidden'
                    }>
                <div className="gallery-controls">
                    <button className="btn btn-transparent" onClick={() => { this.slickTo(directionEnum.prev) }}>
                        <Ink />
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>
                    <button className="btn btn-transparent" onClick={() => { this.slickTo(directionEnum.next) }}>
                        <Ink />
                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                    <button className="btn btn-transparent" onClick={this.props.toggleVisibility}>
                        <Ink />
                        <div className="gallery-toggle">
                            {this.props.galleryVisible ? 'Hide Images ' : 'Show Images '}
                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                        </div>
                    </button>
                </div>
                <GalleryMiniContainer />
                <GalleryComponent
                    className="gallery-secondary"
                    refToSlider={this.sliderRef}
                    sliderRefFunction={sliderRef => this.sliderRef = sliderRef}
                    activeSlideName={activeSlideName}
                    imagesPath={imagesPath}
                    images={images}
                    imageSizeParams={imageSizeParams}
                    settings={this.state.gallerySecondarySettings}/>
            </div>
        );
    }
}

GalleryBottomComponent.propTypes = {
    imagesPath: PropTypes.string.isRequired,
    images: PropTypes.array.isRequired,
    activeSlideName: PropTypes.string
}

export default GalleryBottomComponent;
